(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/behaviors/add-whitty-bg.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/behaviors/add-whitty-bg.js');

'use strict';

svs.numbergames.game.behaviors.AddWhittyBg = Marionette.Behavior.extend({
  addWhittyBg() {
    const noOfNumbers = 8;
    this.$el.addClass('vikinglotto-whitty-bg');
    for (let i = noOfNumbers; i >= 1; i--) {
      this.$el.find('.number-games-content').prepend("<div class=\"whitty-number whitty-number-".concat(i, "\">\n           ").concat(svs.numbergames.rules.utils.vikinglotto.getVikingNumberSvg(i), "\n         </div>"));
    }
  },
  onDomRefresh() {
    if (!svs.vikinglotto.components.play) {
      return;
    }
    this.addWhittyBg(window.innerWidth);
    svs.numbergames.game.animations.vikingWhittyNumbers.animateBackground();
    this._debouncedAnimate = _.debounce(() => {
      svs.numbergames.game.animations.vikingWhittyNumbers.animateBackground({
        isResized: true
      });
    }, 500);
    $(window).on('resize.whitty', this._debouncedAnimate);
  },
  onBeforeDestroy() {
    $(window).off('resize.whitty');
  }
});

 })(window);